var map = {
	"./bg-BG/core": [
		9891,
		891
	],
	"./cs-CZ/core": [
		1929,
		310
	],
	"./da-DK/core": [
		9525,
		525
	],
	"./de-DE/core": [
		5138,
		138
	],
	"./en-US/core": [
		9784
	],
	"./es-ES/core": [
		8583,
		583
	],
	"./fa-IR/core": [
		8267,
		267
	],
	"./fr-FR/core": [
		1936,
		936
	],
	"./hu-HU/core": [
		6355,
		355
	],
	"./id-ID/core": [
		1089,
		89
	],
	"./it-IT/core": [
		3809,
		809
	],
	"./ja-JP/core": [
		8906,
		906
	],
	"./ko-KR/core": [
		7956,
		956
	],
	"./nl-NL/core": [
		609,
		609
	],
	"./pl-PL/core": [
		4062,
		62
	],
	"./pt-BR/core": [
		4347,
		347
	],
	"./ro-RO/core": [
		8160,
		160
	],
	"./ru-RU/core": [
		3420,
		420
	],
	"./sk-SK/core": [
		5107,
		107
	],
	"./sv-SE/core": [
		8240,
		240
	],
	"./tr-TR/core": [
		8376,
		376
	],
	"./uk-UA/core": [
		5470,
		470
	],
	"./uz-UZ/core": [
		4642,
		642
	],
	"./zh-CN/core": [
		9669,
		669
	],
	"./zh-TW/core": [
		4646,
		646
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5165;
module.exports = webpackAsyncContext;